// ChangePasswordModal.js
import { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import ShowAlert from '../Modal/ShowAlert';
import useChangePassword from '../../hooks/useChangePassword';
import '../Login/Login.css';

const ChangePasswordModal = ({ show, handleClose:closeModal }) => {
    const [showPassword, setShowPassword] = useState(false);
    
    const {
        formData,
        errors,
        isSubmitting,
        handleChange,
        handleSubmit,
        resetForm
    } = useChangePassword({
        isModal: true 
    });

    return (
        <Modal show={show} onHide={closeModal} centered className="change-pswrd-modal">
            <Modal.Body>
                <div className="login-container resetpwd-wrapper">
                    <div className="login-box resetpwd-box">
                        <form>
                            <h2>Create New Password</h2>
                            <div className="form-group">
                                <div className="input-icon-container">
                                    <input 
                                        type={showPassword ? 'text' : 'password'}
                                        id="oldpassword"
                                        placeholder="Old Password"
                                        className="form-control"
                                        value={formData.oldPassword}
                                        onChange={(e) => handleChange('oldPassword', e.target.value)}
                                    />
                                    <span className="input-icon">
                                        <img src="/assets/icons/password.png" alt="Password Icon" />
                                    </span>
                                </div>
                                {errors.oldPassword && <span className="text-danger error-text">{errors.oldPassword}</span>}
                            </div>
                            
                            <div className="form-group">
                                <div className="input-icon-container">
                                    <input 
                                        type={showPassword ? 'text' : 'password'}
                                        className="form-control"
                                        id="newpassword"
                                        placeholder="New Password"
                                        value={formData.newPassword}
                                        onChange={(e) => handleChange('newPassword', e.target.value)}
                                    />
                                    <span className="input-icon">
                                        <img src="/assets/icons/password.png" alt="Password Icon" />
                                    </span>
                                </div>
                                {errors.newPassword && <span className="text-danger error-text">{errors.newPassword}</span>}  
                            </div>

                            <div className="form-group">
                                <div className="input-icon-container">
                                    <input 
                                        type={showPassword ? 'text' : 'password'}
                                        id="confirmpassword"
                                        placeholder="Confirm Password"
                                        className="form-control"
                                        value={formData.confirmPassword}
                                        onChange={(e) => handleChange('confirmPassword', e.target.value)}
                                    />
                                    <span className="input-icon">
                                        <img src="/assets/icons/password.png" alt="Password Icon" />
                                    </span>
                                </div>
                                {errors.confirmPassword && <span className="text-danger error-text">{errors.confirmPassword}</span>}
                            </div>

                            <div className="form-check mt-2 show-pwd">
                                <input 
                                    className="form-check-input"
                                    type="checkbox"
                                    checked={showPassword}
                                    onChange={() => setShowPassword(!showPassword)}
                                />
                                <label className="form-check-label">Show Password</label>
                            </div>

                            <Button 
                                className="btn btn-primary btn-lg btn-xl generalBtn"
                                onClick={async () => {const isValid = await handleSubmit();
                                    if (isValid) {
                                        closeModal();
                                    }
                                }}
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? 'Changing...' : 'Submit'}
                            </Button>

                            <div className="change-pwsrd-cancel">
                                <Button 
                                    variant="link"
                                    className="cancel-btn"
                                    size="sm"
                                    onClick={() => {
                                        resetForm();
                                        closeModal();
                                    }}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </form>
                    </div> 
                </div>
            </Modal.Body>

            {/* {alertState.show && (
                <ShowAlert 
                    showModal={alertState.show}
                    closeModal={handleAlertClose}
                    title={alertState.title}
                    message={alertState.message}
                />
            )} */}
        </Modal>
    );
};

export default ChangePasswordModal;